import React, { useState } from "react";
import {
  Typography,
} from "@mui/material";
import AppButton from "./ui/AppButton";
import AppDialog from "./ui/AppDialog";
import AppTextField from "./ui/AppTextField";

const PasswordPrompt = ({ visible, message, onSubmit, onCancel }) => {
  const [password, setPassword] = useState("");

  const handleAccept = () => {
    onSubmit(password);
    setPassword(""); // Limpiar el input de contraseña
  };

  const handleCancel = () => {
    onCancel();
    setPassword(""); // Limpiar el input de contraseña
  };

  return (
    <AppDialog
      open={visible}
      onClose={handleCancel}
      title='Autenticación'
      maxWidth='xs'
      actions={
        <>
          <AppButton onClick={handleCancel} variantType='secondary'>
            Cancelar
          </AppButton>
          <AppButton onClick={handleAccept}>Aceptar</AppButton>
        </>
      }>
        <Typography>{message}</Typography>
        <AppTextField
          autoFocus
          margin='dense'
          label='Contraseña'
          type='password'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleAccept();
            }
          }}
        />
      </AppDialog>
  );
};

export default PasswordPrompt;
